export const uuid = () =>
  `d${+new Date() + Math.random().toString(36).substr(2, 9)}`
